import * as React from "react"
import { Card, CardContent } from "./card"
import { cn } from "../../lib/utils"

interface StatsCardProps {
  title: string
  value: string | number
  icon: React.ReactNode
  iconClassName?: string
  trend?: {
    value: number
    isPositive: boolean
  }
  className?: string
}

export function StatsCard({ 
  title, 
  value, 
  icon, 
  iconClassName = "text-primary",
  trend, 
  className 
}: StatsCardProps) {
  return (
    <Card className={cn("hover:shadow-md transition-shadow", className)}>
      <CardContent className="p-4">
        <div className="flex items-center justify-between">
          <div>
            <div className="text-2xl font-bold tracking-tight">{value}</div>
            <p className="text-sm text-muted-foreground">{title}</p>
            {trend && (
              <div className="flex items-center text-xs mt-1">
                <span
                  className={cn(
                    "font-medium",
                    trend.isPositive ? "text-green-600" : "text-red-600"
                  )}
                >
                  {trend.isPositive ? "+" : ""}{trend.value}%
                </span>
                <span className="text-muted-foreground ml-1">vs last month</span>
              </div>
            )}
          </div>
          <div className={cn("p-2 rounded-full bg-primary/10", iconClassName)}>
            {icon}
          </div>
        </div>
      </CardContent>
    </Card>
  )
} 